import { IressSkeleton } from '@iress-oss/ids-components';
import { FC } from 'react';

export const LoadingPlaceholder: FC<{ height: string }> = props => (
    <IressSkeleton mode={'rect'} height={props.height} data-testid={'loadingPlaceholder'} />
);
